import { type JsonPathLiteral } from "./JsonPathLiteral";
import { parseJsonPath } from "./parseJsonPath";

export function pluck(record: unknown, path: JsonPathLiteral): unknown | undefined {
	const components = parseJsonPath(path);
	let value: unknown = record;

	for (const component of components) {
		if (value == null || typeof value !== "object") {
			return undefined;
		}

		if (component.type === "object") {
			value = (value as Record<string, unknown>)[component.key];
		} else {
			const arr = value as unknown[];
			if (!Array.isArray(arr)) {
				return undefined;
			}

			if (component.index === "append") {
				return arr.length;
			} else if (typeof component.index === "object") {
				value = arr[arr.length - component.index.fromEnd];
			} else {
				value = arr[component.index];
			}
		}
	}

	return value;
}
